import React, { useState } from "react";
import styles from "styles/Dropdown.module.scss";

const Dropdown = ({ options, selectedOption, onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOptionClick = (option) => {
        onSelect(option);
        setIsOpen(false);
    };

    return (
        <div className={styles.dropdown} onClick={() => setIsOpen(!isOpen)}>
            <div className={styles.selectedOption}>
                {options.find((opt) => opt.value === selectedOption)?.label || "Selecciona una opción"}
            </div>
            <div className={`${styles.options} ${isOpen ? styles.open : ""}`}>
                {options.map((option, index) => (
                    <div
                        key={index}
                        className={styles.option}
                        onClick={() => handleOptionClick(option)}
                    >
                        {option.label}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Dropdown;
